<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { LIBRARY_ROUTES } from '@utils/library-routes'

const SECTIONS = [
    { label: 'Library', route: LIBRARY_ROUTES.landing },
    { label: 'Mixes', route: LIBRARY_ROUTES.mixes },
    { label: 'Artists', route: LIBRARY_ROUTES.artists },
    { label: 'Genres', route: LIBRARY_ROUTES.genres },
    { label: 'Shows', route: LIBRARY_ROUTES.shows },
]

const route = useRoute()
const sections = computed(() =>
    SECTIONS.map(section => ({
        ...section,
        isActive: route.name === section.route,
    }))
)
</script>

<template>
    <nav
        class="tabs"
        aria-label="Library sections"
    >
        <RouterLink
            v-for="section in sections"
            :key="section.route"
            :to="{ name: section.route }"
            class="tab"
            :class="{ active: section.isActive }"
            :aria-current="section.isActive ? 'page' : null"
        >{{ section.label }}</RouterLink>
    </nav>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.tabs {
    @include scrollableWrapper;

    display: flex;
    align-items: center;
    margin-bottom: $s-l;

    // match the browse pages' ~40px tabs-to-content desktop rhythm
    @include desktop {
        margin-bottom: $s-xxl;
    }
}

// the app-standard tab treatment (cf. BaseTabPanel): caption text, quiet grey,
// active tab turns white and gets the 4px highlight underline
.tab {
    @extend %caption;

    position: relative;
    padding: 0 0 $s-m;
    color: $c-text-secondary;
    white-space: nowrap;
    text-decoration: none;

    &:hover,
    &:active {
        text-decoration: none;
    }

    &::after {
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 4px;
        content: '';
        background: $c-highlight;
        transform: scaleX(0);

        @include transition(transform);
    }

    &.active {
        color: $c-text-primary;

        &::after {
            transform: scaleX(1);
        }
    }
}

.tab ~ .tab {
    margin-left: $s-xs;
}

@include desktop {
    .tab {
        padding: 0 $s-m $s-m;
    }

    .tab ~ .tab {
        margin-left: $s-m;
    }
}
</style>
